import React, { useEffect, useState } from 'react';

import { Props, Item, ItemClickEvent } from './List.types';
import styles from './List.module.scss';
import * as mapper from './utils/mapper';

import { ListItem } from '../../partials';
import { useHistory } from 'react-router-dom';
import { afTool } from 'routes/routePaths';

const List: React.FC<Props> = ({ calculations, onDeleteButtonClick }) => {
  const [items, setItems] = useState<Item[]>([]);
  const history = useHistory();

  useEffect(() => {
    setItems(calculations.map(mapper.mapCalculationToItem));
  }, [calculations]);

  const handleEdit = (id: Item['calculationId']) => {
    history.push(`${afTool.index}/${id}`);
  };

  const handleClick = (item: Item): ItemClickEvent => {
    return (action) => {
      if (action === 'delete') {
        onDeleteButtonClick();
      }
      if (action === 'edit') {
        handleEdit(item.calculationId);
      }
    };
  };

  return (
    <>
      <div className={styles.list}>
        {items.map((item, index) => (
          <ListItem key={index} item={item} onClick={handleClick(item)} />
        ))}
      </div>
    </>
  );
};

export default List;
